export const socialsData = {
    github: 'https://github.com/hxckinson',
    // facebook: 'https://www.facebook.com/',
    linkedIn: 'https://fr.linkedin.com/in/st%C3%A9phane-devaux-9ba364150',
    instagram: 'https://www.instagram.com/hcks_artifacts/',
    // codepen: 'https://codepen.io/',
    // twitter: 'https://twitter.com/',
    // reddit: 'https://www.reddit.com/user/',
    // blogger: 'https://www.blogger.com/',
    // medium: 'https://medium.com/@',
    // stackOverflow: 'https://stackoverflow.com/users/',
    // gitlab: 'https://gitlab.com/',
    // youtube: 'https://youtube.com/'
}